import {  ADD_MEMBER, ADD_MEMBER_ERROR, DELETE_MEMBER, RESET_ADD_MEMBER, USER_OPTIONS, LOGO_UPDATE, ADD_TRAINER, ADD_TRAINER_ERROR, DELETE_TRAINER} from '../../Actions/actionTypes'

const initState = {
    AddMember: null
 }

 export default function(state = initState, action){

    switch(action.type){
        
        case ADD_MEMBER:
           return {
             ...state,
             AddMember: true
           }
        case ADD_MEMBER_ERROR: 
            return {
            ...state,
            AddMember: false
        } 
        case DELETE_MEMBER:
           return {
               ...state,
               deleteMember: true
           } 
        case RESET_ADD_MEMBER: 
            return {
            
            AddMember: null
        }  
        case USER_OPTIONS: 
            return {
                ...state,
               AddMemberoOptions: true
        }  
        case LOGO_UPDATE: 
            return {
                ...state,
               LogoUpdate: true
        }  
        case ADD_TRAINER:
           return {
             ...state,
             AddRrainer: true
           }
        case ADD_TRAINER_ERROR: 
            return {
            ...state,
            AddTrainer: false
        } 
        case DELETE_TRAINER:
           return {
               ...state,
               deleteTrainer: true
           } 
        default:
            return state     
    }
}